export default {
  confirmDelete: 'Odstrániť "{0}"?',
  emptyMessage: 'Nie sú dostupné žiadne {0}.',
  uploadButtonLabel: 'Nahrať {0}',
  files: 'súbory',
};
